import Vue from 'vue'
import Router from 'vue-router'

import v1 from '@/router/v1'
import v2 from '@/router/v2'
import v3 from '@/router/v3'
Vue.use(Router);

const router = new Router({
  routes: v1.concat(v2).concat(v3),
  mode: 'history',
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  next()
});

export default router
